const course = [
  {
    path: "/course/classify",
    name: "courseClassify",
    component: () => import("@/view/course/classify"),
  },
  {
    path: "/course/info",
    name: "courseInfo",
    component: () => import("@/view/course/info"),
  },
  {
    path: "/course/info/form",
    name: "courseInfoForm",
    component: () => import("@/view/course/info/Form"),
  },
  {
    path: "/course/packageClassify",
    name: "coursePackageClassify",
    component: () => import("@/view/course/packageClassify"),
  },
  {
    path: "/course/package",
    name: "coursePackage",
    component: () => import("@/view/course/package"),
  },
  {
    path: "/course/studyTask",
    name: "courseStudyTask",
    component: () => import("@/view/course/studyTask"),
  },
  {
    path: "/course/bannerManage",
    name: "courseBannerManage",
    component: () => import("@/view/course/bannerManage"),
  }
];
export default course;
